import moment from "moment";

/* eslint-disable */
export const DateUtils = {
    defaultDateFormat: "DD-MM-YYYY",
    defaultDateTimeFormat: "DD-MM-YYYY HH:mm:ss",
    timestampFormat: "YYYY-MM-DD-HH-mm-ss",
    dateFormat: "DD-MM-YYYY",
    defaultTimeOnlyFormat: "HH:mm",
    defaultYearOnlyFormat: "YYYY",
    polishDateFormat: "DD MMMM YYYY",
    polishDateTimeFormat: "DD MMMM YYYY HH:mm:ss",

    timestampNow() {
        return moment().format(this.timestampFormat);
    },

    displayDateTime(dateString) {
        return moment(dateString).format(this.defaultDateTimeFormat);
    },

    displayDate(dateString) {
        return moment(dateString).format(this.dateFormat);
    },

    isInThePast(dateString) {
        return moment().isSameOrAfter(dateString);
    },

    isInTheFuture(dateString) {
        return moment().isSameOrBefore(dateString);
    },

    dateAsString(date) {
        return moment(date).format(this.dateFormat);
    },

    formatDate(date, format) {
        return moment(date).format(format);
    },

    formatDateFromString(dateString, inputFormat, outputFormat) {
        return moment(dateString, inputFormat).format( outputFormat);
    },

    getTimeOnly(date) {
        return moment(date, "HH:mm:ss").format(this.defaultTimeOnlyFormat);
    },

    getYearOnly(date) {
        return moment(date, "HH:mm:ss").format(this.defaultYearOnlyFormat);
    },

    displayDateOnlyInPolishFormat(date) {
        return moment(date).locale('pl').format(this.polishDateFormat)
    },

    displayDateTimeInPolishFormat(dateString) {
        return moment(dateString).locale('pl').format(this.polishDateTimeFormat);
    },
    isDateEarlier(date1, date2) {
        return this.displayDate(date1) < this.displayDate(date2);
    },
    isTimeEarlier(time1, time2) {
        return time1 != null && time2 != null && this.getTimeOnly(time1) < this.getTimeOnly(time2);
    },
    formatFormDate(date) {
        return (date instanceof Date) ? this.dateAsString(date) : date;
    },
    formatFormTime(date) {
        return (date instanceof Date) ? this.getTimeOnly(date) : date;
    },
};
